import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class LiquidationToBeAssignedService {

  routeParams: any;

  constructor(private _http: HttpClient) {}

  getLiquidation(district): Observable<any[]> {
    return this._http.get<any[]>(`${environment.BACKEND}liquidacion/listToBeAssigned/${district}`);
  }

  getProcurators(district): Observable<any> {
    return this._http.get(`${environment.BACKEND}liquidacion/listProcuratorByDistrict/${district}`);
  }

  getAllProcurators(): Observable<any> {
    return this._http.get(`${environment.BACKEND}liquidacion/listAllProcurators`);
  }

  distributeLiquidation(procurator, id_district): Observable<any> {
    return this._http.post(`${environment.BACKEND}liquidacion/distribute`, {procurator: procurator, id_district: id_district});
  }

  reasignateLiquidation(obj) {
    return this._http.post(`${environment.BACKEND}liquidacion/reassignate`, {obj: obj});
  }

  getCourt(): Observable<any> {
    return this._http.get<any>(`${environment.BACKEND}court/list`);
  }

  getDistrict(): Observable<any> {
    return this._http.get<any>(`${environment.BACKEND}district/list`);
  }

  getPreassigned(page, id_district) {
    const httpParams = new HttpParams()
      .set('id_district', id_district)
      .set('pageNumber', page.pageNumber)
      .set('size', page.size);

    return this._http.get<any>(`${environment.BACKEND}liquidacion/listPreAssigned`, {
      params: httpParams
    });
  }

  confirmSelected(preassignation) {
    return this._http.post(`${environment.BACKEND}liquidacion/confirmAssignedLiquidation`, {liquidations: preassignation});
  }

  confirmAll(id_district) {
    return this._http.post(`${environment.BACKEND}liquidacion/confirmAssignedLiquidation`, {liquidations: null, id_district: id_district});
  }

  cancelSelected(preassignation) {
    return this._http.post(`${environment.BACKEND}liquidacion/cancelAssignedLiquidation`, {liquidations: preassignation});
  }

  cancelAll(id_district) {
    return this._http.post(`${environment.BACKEND}liquidacion/cancelAssignedLiquidation`, {liquidations: null, id_district: id_district});
  }

}

